var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isEnded)?_c('div',[_vm._t("ended")],2):_c('div',[_vm._t("default",null,{"days":_vm.days,"hours":_vm.hours,"minutes":_vm.minutes,"seconds":_vm.seconds})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }